<template>
  <div>
    <div class="bg">
      <div class="row mb-4">
        <div class="col-12">
          <img src="/img/arrow-left.svg" class="mt-4" height="30" @click="$router.back()" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="row center">
            <div class="screen">
              <div class="col-sm-12 col-12">
                <div v-if="!idUsuario">
                  <h1 class="title dark-blue">Olá, vamos fazer sua inscrição</h1>
                  <h4 class="sub-title">Preencher os dados abaixo</h4>
                </div>
                <div v-else>
                  <h1 class="title dark-blue">Vamos editar seus dados</h1>
                  <h4 class="sub-title">Altere os dados abaixo</h4>
                </div>

                <ValidationObserver ref="dadosPessoais">
                  <form>
                    <!-- NOME -->
                    <div class="field mb-4 mt-5 m-mt-1">
                      <ValidationProvider name="nome" rules="required" mode="passive" v-slot="{ errors, classes }">
                        <div class="field">
                          <input type="text" class="input" :style="nome && 'color: #0D4275'" :class="classes"
                            v-model="nome" @focus="clearDadosPessoais" maxlength="100" autocomplete="nope" />
                          <label :class="nome && 'filled'">Escreva aqui seu nome completo</label>
                          <span class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>


                    <!-- NUMERO PESQUISADOR -->
                    <div class="field mb-4">
                      <ValidationProvider name="numero pesquisador" mode="passive" v-slot="{ errors, classes }">
                        <select class="select" :style="nomePesquisador && 'color: #0D4275;font-weight: 600;'"
                          v-model="nomePesquisador" @focus="clearDadosPessoais" :class="classes">
                          <option :value="undefined">
                            Número do pesquisador
                          </option>
                          <option v-for="pesquisador in pesquisadores" :key="pesquisador" :value="pesquisador">
                            {{ pesquisador }}
                          </option>
                        </select>
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <!-- CPF -->
                    <div class="field mb-4">
                      <ValidationProvider mode="passive" name="CPF" rules="required|cpf" v-slot="{ errors, classes }">
                        <div class="field">
                          <input :style="cpf && 'color: #0D4275'" type="tel" class="input" :class="classes"
                            v-model="cpf" @focus="clearDadosPessoais" v-mask="'###.###.###-##'" maxlength="20"
                            autocomplete="nope" />
                          <label :class="cpf && 'filled'">Qual é o seu CPF?</label>
                          <span class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>

                    <!-- EMAIL -->
                    <div class="field mb-4">
                      <ValidationProvider name="email" mode="passive" rules="required|email"
                        v-slot="{ errors, classes }">
                        <div class="field">
                          <input :style="email && 'color: #0D4275'" type="text" class="input" :class="classes"
                            v-model="email" @focus="clearDadosPessoais" maxlength="100" autocomplete="nope" />
                          <label :class="email && 'filled'">Qual é o seu melhor email?</label>
                          <span class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>

                    <!-- TELEFONE -->
                    <div class="field mb-4">
                      <ValidationProvider name="telefone" mode="passive" rules="required|min:15"
                        v-slot="{ errors, classes }">
                        <div class="field">
                          <input :style="telefone && 'color: #0D4275'" type="tel" class="input" :class="classes"
                            v-model="telefone" @focus="clearDadosPessoais"
                            v-mask="['(##) ####-####', '(##) #####-####']" autocomplete="nope" />
                          <label :class="telefone && 'filled'">Insira o seu telefone com DDD</label>
                          <span class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>

                    <!-- SENHA -->
                    <!-- <div v-if="!idUsuario" class="field mb-4 mt-2">
                      <ValidationProvider name="senha" rules="required|min:6" mode="passive"
                        v-slot="{ errors, classes }">
                        <div class="field">
                          <input :type="showPassword ? 'text' : 'password'" class="input"
                            :style="senha && 'color: black'" :class="classes" v-model="senha"
                            @focus="clearDadosPessoais" maxlength="100" autocomplete="nope" />
                          <label :class="senha && 'filled'">Digite sua senha</label>
                          <img class="hide-show" @click="togglePasswordVisibility"
                            :src="showPassword ? '/img/eye-closed.svg' : '/img/eye-open.svg'" />

                          <span class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div> -->

                    <h1 class="title dark-blue mt-5 mb-5">Informações importantes</h1>

                    <!-- DATA NASCIMENTO -->
                    <div class="field mb-4">
                      <ValidationProvider mode="passive" name="nascimento"
                        rules="required|data_nascimento|data_maior_idade" v-slot="{ errors, classes }">
                        <div class="field">
                          <input :style="nascimento && 'color: #0D4275'" type="tel" class="input" :class="classes"
                            v-model="nascimento" @focus="clearDadosPessoais" v-mask="'##/##/####'"
                            autocomplete="nope" />
                          <label :class="nascimento && 'filled'">Qual sua data de nascimento?</label>
                          <span class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>

                    <!-- CIDADE -->
                    <div class="field mb-4">
                      <ValidationProvider name="cidade" mode="passive" rules="required" v-slot="{ errors, classes }">
                        <select class="select" :style="cidade && 'color: #0D4275;font-weight: 600;'" v-model="cidade"
                          @focus="clearDadosPessoais" :class="classes">
                          <option :value="undefined">
                            Qual é a sua cidade?
                          </option>
                          <option v-for="cidade in cidades" :key="cidade" :value="cidade">
                            {{ cidade }}
                          </option>
                        </select>
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <!-- BAIRRO -->
                    <div class="field mb-4 mt-5 m-mt-1">
                      <ValidationProvider name="bairro" rules="required" mode="passive" v-slot="{ errors, classes }">
                        <div class="field">
                          <input type="text" class="input" :style="bairro && 'color: #0D4275'" :class="classes"
                            v-model="bairro" @focus="clearDadosPessoais" maxlength="100" autocomplete="nope" />
                          <label :class="bairro && 'filled'">Qual seu bairro?</label>
                          <span class="invalid-feedback">{{ errors[0] }}</span>
                        </div>
                      </ValidationProvider>
                    </div>

                    <!-- SEXO -->
                    <div class="field mb-4">
                      <ValidationProvider name="sexo" mode="passive" rules="required" v-slot="{ errors, classes }">
                        <select class="select" :style="sexo && 'color: #0D4275;font-weight: 600;'" v-model="sexo"
                          @focus="clearDadosPessoais" :class="classes">
                          <option :value="undefined">
                            Sexo
                          </option>
                          <option value="M">Masculino</option>
                          <option value="F">Feminino</option>
                        </select>
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <!-- MORA SOZINHO-->
                    <div class="field mb-4">
                      <ValidationProvider name="sozinho" mode="passive" rules="required" v-slot="{ errors, classes }">
                        <select class="select" :style="sozinho && 'color: #0D4275;font-weight: 600;'" v-model="sozinho"
                          @focus="clearDadosPessoais" :class="classes">
                          <option :value="undefined">
                            Você mora sozinho?
                          </option>
                          <option value="S">Sim</option>
                          <option value="N">Não</option>
                        </select>
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <!-- ESCOLARIDADE-->
                    <div class="field mb-4">
                      <ValidationProvider name="escolaridade" mode="passive" rules="required"
                        v-slot="{ errors, classes }">
                        <select class="select" :style="escolaridade && 'color: #0D4275;font-weight: 600;'"
                          v-model="escolaridade" @focus="clearDadosPessoais" :class="classes">
                          <option :value="undefined">
                            Qual a sua escolaridade?
                          </option>
                          <option value="Analfabeto">Analfabeto</option>
                          <option value="Ensino fundamental incompleto">Ensino fundamental incompleto</option>
                          <option value="Ensino fundamental completo">Ensino fundamental completo</option>
                          <option value="Ensino médio incompleto">Ensino médio incompleto</option>
                          <option value="Ensino médio completo">Ensino médio completo</option>
                          <option value="Ensino superior ou mais">Ensino superior ou mais</option>
                        </select>
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                    <!-- POLITICA PRIVACIDADE -->
                    <div class="field mb-4">
                      <ValidationProvider name="privacidade" mode="passive" rules="required"
                        v-slot="{ errors, classes }">
                        <select class="select" :style="privacidade && 'color: #0D4275;font-weight: 600;'"
                          v-model="privacidade" @focus="clearDadosPessoais" :class="classes">
                          <!-- <option :value="undefined">
                            Aceita nossa politica de privacidade?
                          </option> -->
                          <option value="S">Sim</option>
                          <option value="N">Não</option>
                        </select>
                        <span class="font-small dark-blue-normal"> Aceita nossa politica de privacidade?</span>
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <!-- COMPARTILHAMENTO DE DADOS -->
                    <div class="field mb-4">
                      <ValidationProvider name="compartilhamento" mode="passive" rules="required"
                        v-slot="{ errors, classes }">
                        <select class="select" :style="compartilhamento && 'color: #0D4275;font-weight: 600;'"
                          v-model="compartilhamento" @focus="clearDadosPessoais" :class="classes">
                          <option value="S">Sim</option>
                          <option value="N">Não</option>
                        </select>
                        <span class="font-small dark-blue-normal"> Aceita nossa politica de compartilhamento de
                          dados?</span>
                        <span class="invalid-feedback">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                    <div class="mt-5 mb-5">
                      <button class="continue-btn" :disabled="loading" @click.prevent="handleDadosPessoais">
                        <span>FINALIZAR </span>
                      </button>
                    </div>


                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-bottom-sheet-vue2 ref="warning" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info"> Tente novamente mais tarde</h5>

        </div>
      </vue-bottom-sheet-vue2>
      <vue-bottom-sheet-vue2 ref="update" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info"> Dados atualizados ✅</h5>

        </div>
      </vue-bottom-sheet-vue2>

      <vue-bottom-sheet-vue2 ref="exists" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pl-4 pr-4 pb-5">
          <h5 class="text-info">O CPF informado já esta cadastrado, por favor realize o login</h5>
          <button class="continue-btn mt-4" :disabled="loading" @click.prevent="$router.push('/login')">
            <span>LOGIN</span>
          </button>
        </div>
      </vue-bottom-sheet-vue2>
    </div>
    <Loading v-if="loading" />
  </div>
</template>

<script>
import auth from "../auth";
import api from "../axiosConfig";
import moment from "moment";
import VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";

export default {
  components: {
    VueBottomSheetVue2,
    Loading: () => import("./Loading.vue"),
  },
  data() {
    return {
      loading: false,
      sozinho: undefined,
      escolaridade: undefined,
      privacidade: 'S',
      compartilhamento: 'S',
      sexo: undefined,
      senha: undefined,
      showPassword: false,
      mobile: false,
      auth,
      nome: "",
      nomePesquisador: undefined,
      nascimento: undefined,
      email: "",
      telefone: "",
      cpf: "",
      estado: undefined,
      ano: undefined,
      rg: undefined,
      cidade: undefined,
      bairro: undefined,
      complemento: undefined,
      idUsuario: undefined,
      cidades: [
        "Ceilândia",
        "Samambaia",
        "Taguatinga",
        "Plano Piloto",
        "Planaltina",
        "Gama",
        "Águas Claras",
        "Guará",
        "Santa Maria",
        "Recanto das Emas",
        "Sol Nascente/Pôr do Sol",
        "São Sebastião",
        "Vicente Pires",
        "Sobradinho II",
        "Jardim Botânico",
        "Sobradinho",
        "Riacho Fundo II",
        "Itapoã",
        "Paranoá",
        "Brazlândia",
        "Sudoeste/Octogonal",
        "Arniqueira",
        "Lago Sul",
        "Lago Norte",
        "Riacho Fundo",
        "Cruzeiro",
        "Park Way",
        "Núcleo Bandeirante",
        "Candangolândia",
        "Fercal",
        "Varjão",
        "SIA",
        "SCIA",
        "Arapoanga",
      ],
      pesquisadores: [
        "001 - Ceilândia-DF",
        "002 - Ceilândia-DF",
        "003 - Ceilândia-DF",
        "004 - Samambaia-DF",
        "005 - Samambaia-DF",
        "006 - Santa Maria-DF",
        "007 - Santa Maria-DF",
        "008 - Recanto Das Emas-DF",
        "009 - Recanto Das Emas-DF",
        "010 - Gama-DF",
        "011 - Gama-DF",
        "012 - Brazlândia-DF",
        "013 - Brazlândia-DF",
        "014 - Planaltina-DF",
        "015 - Planaltina-DF",
        "016 - Arapoanga-DF",
        "017 - Arapoanga-DF",
        "018 - Sol Nascente-DF",
        "019 - Sol Nascente-DF",
        "020 - Sol Nascente-DF",
      ],
    };
  },
  created() {
    this.carregarDadosUsuario();
  },
  mounted() {

  },

  watch: {
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    clearDadosPessoais() {
      this.$nextTick(() => {
        this.$refs.dadosPessoais.reset(); // Reset validation errors
      });
    },

    async carregarDadosUsuario() {
      this.loading = true;
      try {

        const idUsuario = window.sessionStorage.getItem("idUsuario");
        if (idUsuario) {
          this.idUsuario = JSON.parse(idUsuario);

          const response = await api.get(`/users/${this.idUsuario}`);

          const userData = response.data;

          this.nome = userData.nome;
          this.nomePesquisador = userData.nomePesquisador;
          this.cpf = userData.cpf;
          this.email = userData.email;
          this.telefone = userData.telefone;
          this.nascimento = moment(userData.dataNascimento).format("DD/MM/YYYY");
          this.cidade = userData.cidade;
          this.bairro = userData.bairro;
          this.sexo = userData.genero;
          this.sozinho = userData.sozinho ? 'S' : 'N';
          this.escolaridade = userData.escolaridade;
          this.privacidade = userData.politicaPrivacidade ? 'S' : 'N';
          this.compartilhamento = userData.politicaDados ? 'S' : 'N';
        }
      } catch (error) {
        this.$refs.warning.open();
      }
      this.loading = false;
    },

    async handleDadosPessoais() {
      const valid = await this.$refs.dadosPessoais.validate();
      if (!valid) return;

      await this.dadosPessoais();

    },

    async dadosPessoais() {

      // Remove a máscara do CPF e pega os 4 primeiros dígitos
      const cpfSemMascara = this.cpf.replace(/\D/g, ''); // Remove tudo que não for número
      const senha = cpfSemMascara.substring(0, 4); // Pega os 4 primeiros dígitos

      try {
        this.loading = true;
        var data = {
          nome: this.nome,
          nomePesquisador: this.nomePesquisador,
          cpf: this.cpf,
          email: this.email,
          telefone: this.telefone,
          senha: senha,
          dataNascimento: moment(this.nascimento, "DD/MM/YYYY").format("YYYY-MM-DD"),
          cidade: this.cidade,
          bairro: this.bairro,
          genero: this.sexo,
          sozinho: this.sozinho === 'S',
          escolaridade: this.escolaridade,
          politicaPrivacidade: this.privacidade === 'S',
          politicaDados: this.compartilhamento === 'S',
        };


        if (this.idUsuario) {
          await api.patch(`/users/${this.idUsuario}`, data);
          this.$router.push("/sidebar");

        } else {
          const response = await api.post('/users', data);
          const id = JSON.stringify(response.data.id);
          window.sessionStorage.setItem("idUsuario", id);
          this.$router.push("/boasvindas");
        }
        this.loading = false;


      } catch (error) {
        this.loading = false;
        if (error.response.status === 409) {
          this.$refs.exists.open();
          return;
        }
        this.$refs.warning.open();
      }
    },

  },

};
</script>
<style>
.hide-show {
  position: absolute;
  right: 15px;
  top: 22px;
  transition: 0.2s ease all;
  cursor: pointer;
}

.f-14 {
  font-size: 14px;
}

.f-20 {
  font-size: 20px;
}

.text-left {
  text-align: left;
}

.container-anual-mensal {
  gap: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.button-anual-mensal {
  position: relative;
  padding: 10px 24px;
  border-radius: 12px;
  border: 1px solid #ccc;
  background: #f7f7f7;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  color: #8A92A0;
}

.button-anual-mensal.active {
  background: #6c7891;
  color: white;
}

.badge-anual-mensal {
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background: white;
  color: #6c7891;
  padding: 4px 10px;
  font-size: 10px;
  border-radius: 8px;
  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  text-wrap-mode: nowrap;
}

.active .badge-anual-mensal {
  background: #f0f0f0;
}


.swiper-pagination-bullet {
  background: #4caf50 !important;
  /* Cor do ponto ativo */
}

/* Cor do ponto ativo da paginação */
.swiper-pagination-bullet-active {
  background: #4caf50 !important;
  /* Cor do ponto ativo */
}

/* Estilo adicional para quando passar o mouse */
.swiper-pagination-bullet:hover {
  background: #8bc34a !important;
}

.swiper-plans-container {
  width: 100%;
  padding: 10px;
}

.gift-size {
  width: 18px;
}

.arrow-size {
  width: 9px;
}

.align-self-center {
  align-self: center;
}

.align-self-anchor-center {
  align-self: anchor-center;
}

.font-dark-blue {
  color: #0D4275;
}

.gift-text {
  color: #0D4275 !important;
}

.ghost-dark-blue {
  font-weight: bold;
  font-size: 12px;
  padding: 10px 20px 10px 20px;
  border: 1px solid #425994;
  border-radius: 8px;
  background: #fff;
  color: #425994;
  -webkit-box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  display: inline-block;
}

.ghost-dark-blue-selected {
  font-weight: bold;
  font-size: 12px;
  padding: 10px 20px 10px 20px;
  border: 1px solid #0D4275;
  border-radius: 8px;
  background: #0D4275;
  color: #fff;
  -webkit-box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  display: inline-block;
}

.card-plan-list {
  list-style-image: url("/img/checked-item.svg");
}

.card-plan-list-selected {
  list-style-image: url("/img/checked-white.svg");
}

.oversize-badge {
  margin-top: -12px !important;
}

.mb-7 {
  margin-bottom: 7rem !important;
}

.uppercase {
  text-transform: uppercase;
}

.pointer {
  cursor: pointer;
}

.field {
  position: relative;
}

label {
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 22px;
  transition: 0.2s ease all;
  font-size: 14px;
  color: #0D4275;
}

.filled {
  top: 2px !important;
  color: #0D4275;
}

input:focus~label {
  top: 2px;
  color: #0D4275;
  font-weight: bold;
}

.align-start {
  align-items: start;
}

.align-anchor-center {
  align-items: anchor-center;
}

.chosen-item {
  color: #ffffff94 !important;
}

.card-checkout-plan {
  justify-content: space-between;
  display: flex;
}

.step-description {
  margin-top: 14px;
  text-wrap: nowrap;
  font-size: 12px;
}

.pipe {
  height: 5rem;
  border-left: 2px solid #e5e5e5;
}

.flex {
  display: flex;
}

.self-center {
  align-self: center;
}

.medium {
  padding-top: 23px;
  font-size: 1.5vw;
  font-weight: 800;
}

.big {
  font-size: 5rem !important;
}

.font-small {
  font-size: 0.8vw;
}

.card-optional-plan {
  display: flex;
  justify-content: space-between;
}

.space-between {
  justify-content: space-between;
}

.card-optional {
  padding: 12px;
}

.border-left-optional {
  border-left: 1px solid #e5e5e54d;
}

.optional-small {
  font-size: 24px;
  font-weight: 600;
}

.optional-price {
  display: flex;
  align-items: baseline;
  font-size: 48px;
  font-weight: 800;
  margin-top: 1rem;
}

.text-info {
  color: #425994 !important;
}

a {
  color: #089f17;
  text-decoration: underline;
  background-color: transparent;
}

.line {
  border-left: 1px solid #e5e5e5;
  height: 70px;
}

.line-optional-plan {
  border-left: 1px solid #e5e5e5;
  height: 9rem;
}

.badge-plan {
  padding: 5px 10px 5px 10px;
  font-weight: 500;
  border-radius: 8px;
  color: #425994;
  background-color: #e9e9e9;
}

.footer-plan {
  padding: 12px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #0D4275;
  color: white;
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tooltip-plan {
  cursor: pointer;
  position: relative;
  display: inline-block;
}

.benefit-title {
  font-size: 16px;
  font-weight: 700;
}

.benefit-content {
  font-size: 14px;
  font-weight: normal;
  color: #acb4be;
}

.tooltip-plan .tooltip-content {
  background-color: #2a2e43;
  color: #fff;
  text-align: left;
  padding: 36px;
  border-radius: 12px;
  position: absolute;
  z-index: 3;
  width: 130%;
}

.visible {
  visibility: visible;
}

.tooltip-content::after {
  content: "";
  position: absolute;
  top: 0%;
  left: 65%;
  right: 30%;
  bottom: 100%;
  margin-top: -25px;
  border-width: 15px;
  border-style: solid;
  border-color: transparent transparent #2a2e43 transparent;
}

.recom-word {
  text-align: center;
  font-weight: bold;
  color: #0D4275;
  margin-top: 0;
  margin-bottom: 0px;
}

.end {
  text-align: end;
}

.recommended {
  border: 2px solid #0D4275 !important;
}

.list {
  margin-top: 8px;
}

.gray {
  color: #0D4275 !important;
}

.not-included {
  text-decoration: line-through;
}

.wiped {
  color: #d1d5dc;
}

.underline {
  text-decoration: underline;
}

.price-checkout {
  align-self: center;
  justify-content: center;
  display: flex;
  font-size: 5.2vw;
  font-weight: 800;
}

.price {
  justify-content: center;
  display: flex;
  font-size: xxx-large;
  font-weight: 800;
}

.small {
  padding-top: 15px;
  font-size: small;
  font-weight: 800;
}

.card-plan-itens {
  color: #425994;
  padding-inline-start: 20px !important;
}

.white {
  color: #ffffff;
}

.align-center {
  text-align: center;
}

.flex>h6,
h4 {
  margin-bottom: 0px !important;
}

.card-plan {
  cursor: pointer;
  color: #425994;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 12px;
  border: 1px solid #BCE0FD;
}

.card-checkout {
  color: #ffffff;
  padding: 24px;
  background-color: #0D4275;
  border-radius: 12px;
}

.chosen {
  color: #ffffff !important;
  background-color: #0D4275 !important;
}

.badge-secondary {
  padding: 5px 10px 5px 10px;
  border-radius: 12px;
  color: #425994;
  background-color: #e9e9e9;
}

.badge-chosen {
  padding: 5px 10px 5px 10px;
  border-radius: 12px;
  color: #425994;
  background-color: #ffffff;
}

.dashed {
  padding: 15px;
  border-radius: 12px;
  border: 2px dashed #0D4275;
}

.dashed-optional {
  border: 1px dashed #0D4275;
}

.screen {
  width: 100%;
}

.weight-600 {
  font-weight: 600;
}

.bg {
  background-image: url("/img/bike-mundo.svg");
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: 20%;
  background-color: #f9f9f9;
  min-height: 100%;
}

.title {
  margin-top: 3rem;
  font-size: 2.2vw;
  font-weight: 700;
}

.gray {
  color: #505b71;
}

.dark-blue {
  font-size: 2.2vw;
  font-weight: 700;
  color: #0D4275 !important;
}

.bold {
  font-weight: 700;
}

.sub-title {
  color: #0D4275;
}

.column-left {
  text-align: center;
  float: left;
  width: 10%;
}

.column-right {
  padding-left: 10px;
  float: left;
  width: 90%;
  color: #0D4275;
  font-size: 16px;
  font-weight: normal;
}

.step-by-step:after {
  content: "";
  display: table;
  clear: both;
}

.sub-input {
  color: #0D4275;
  font-size: 12px;
}

.input {
  font-size: 14px;
  display: block;
  width: 100%;
  height: 64px;
  border: 1px solid #BCE0FD;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 10px 16px 0px 16px;
  border-radius: 5px;
  background: #fff;

}

.selected {
  color: black;
  font-weight: 600;
}

.select {
  display: block;
  width: 100%;
  height: 64px;
  border: 1px solid #BCE0FD;
  padding: 0px 16px;
  border-radius: 5px;
  background: #fff;
  font-size: 14px;
  color: #0D4275;
  font-weight: normal;
  appearance: none;
  /* Remove a aparência padrão */
  -webkit-appearance: none;
  -moz-appearance: none;
  background: url("/img/arrow-down.svg") no-repeat right 20px center;
  background-size: 12px;
}

.input::placeholder {
  color: #0D4275;
  font-size: 14px;
  font-weight: normal;
}

.continue-btn {
  font-size: 18px;
  padding: 10px 20px 10px 20px;
  border: 1px solid #0D4275;
  border-radius: 8px;
  background: #0D4275;
  color: #fff;
  box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1),
    0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

.continue-btn-d {
  font-size: 18px;
  padding: 10px 20px 10px 20px;
  border-radius: 8px;
  color: #fff;
  box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1),
    0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

.back-btn {
  border: 1px solid transparent;
  font-size: 18px;
  padding: 10px 20px 10px 20px;
  border-radius: 8px;
  background: #caced9;
  color: #505b71;
}

.continue-btn:disabled,
button[disabled] {
  font-size: 18px;
  padding: 10px 20px 10px 20px;
  border: 1px solid #d1d5dc;
  /* border-radius: 8px; */
  background: #d1d5dc;
  color: #ffffff;
  box-shadow: 9px 12px 30px 0px rgba(0, 0, 0, 0.1),
    0 6px 20px 0 rgba(0, 0, 0, 0.1);
}

.choice-btn {
  padding: 10px 15px 10px 15px;
  border: none;
  border-radius: 8px;
  background: #ffffff;
  color: #089f17;
}

.second-choice-btn {
  padding: 10px 15px 10px 15px;
  border: none;
  border-radius: 8px;
  background: #ffffff;
  color: #8a92a0;
}

.ghost {
  text-align: center;
  padding: 10px 15px 10px 15px;
  border: 1px solid #8a92a0;
  border-radius: 8px;
  background: #ffffff;
  color: #8a92a0;
  text-wrap: nowrap;
}

.radius {
  border-radius: 12px !important;
}

.chosen-btn {
  padding: 10px 15px 10px 15px;
  border: none;
  border-radius: 8px;
  background: #0D4275;
  color: #ffffff;
}

.steps {
  margin-left: 5%;
  left: 44%;
  right: 57%;
}

.center {
  display: flex;
  align-items: center;
}

.left-side {
  background-color: #fff;
  border-top-right-radius: 32px;
  border-bottom-right-radius: 32px;
}

.row {
  margin: 0;
}

*:focus {
  outline: 0;
}

input:focus::placeholder {
  color: transparent;
}

.invalid-feedback {
  font-size: 14px;
}

@media (max-width: 768px) {

  .m-mt-1 {
    margin-top: 1rem !important;
  }

  .m-justify-center {
    justify-content: center;
  }

  /* label {
    font-weight: bold;
  } */

  .font-small {
    font-size: 12px;
  }

  .bg {
    background-image: none !important;
  }

  .w-105 {
    width: 105%;
  }

  .benefit-content {
    padding-bottom: 40px;
  }

  .tooltip-plan .tooltip-content {
    background-color: #2a2e43;
    color: #fff;
    text-align: left;
    padding: 24px 0 10px 0 !important;
    border-top-right-radius: 12px;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 5;
    width: 100%;
  }

  .card-checkout-title {
    font-size: 5.7vw;
  }

  .card-checkout {
    padding: 4px 14px;
  }

  .medium {
    padding-top: 12px;
    font-size: 4.5vw;
    font-weight: 500;
  }

  .big {
    font-size: 30px !important;
  }

  .card-checkout-plan {
    display: block;
  }

  .justify-center {
    justify-content: center;
  }

  .pipe {
    border-left: 0 !important;
    height: 0 !important;
    border-bottom: 2px solid #e5e5e5;
  }

  .border-left-optional {
    border-left: 0 !important;
  }

  .optional-price {
    margin-top: 0 !important;
  }

  .card-optional {
    padding: 0 !important;
    width: 100%;
  }

  .grid {
    display: grid;
  }

  .mr-5 {
    margin-right: 15px !important;
  }

  .sub-title {
    font-size: 16px;
    text-align: center;
  }

  .desktop {
    display: none;
  }

  .title {
    margin-top: 0;
    font-size: 23px;
    text-align: center;
  }

  .left-side {
    display: none;
  }

  .ml-5,
  .mx-5 {
    margin-left: 0 !important;
  }

  .continue-btn {
    width: 100%;
  }

}
</style>
